import { useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import {
  BottomLinksBlockStyled,
  BottomLinksStyled,
  FooterStyled,
  MainTextBlockStyled,
  UpperBlockStyled,
} from '../styles/FooterNew.styles';

export interface FooterProps {
  withMarginTop: boolean;
  withBackgroundColor: boolean;
  complianceFlowFooter?: boolean;
}

const Footer = ({ withMarginTop, withBackgroundColor, complianceFlowFooter = false }: FooterProps) => {
  const theme = useTheme();
  const isPad = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <>
      {withMarginTop && (
        <UpperBlockStyled withBackgroundColor={withBackgroundColor} />
      )}
      <FooterStyled container withBackgroundColor={withBackgroundColor}>
        <MainTextBlockStyled complianceFlowFooter={complianceFlowFooter} item lg={5.6}>
          {isPad
            ? 'TheGuarantors is a licensed insurance agent and broker. For more detailed information, please see our Legal/ Regulatory Notice.'
            : 'TheGuarantors is a licensed insurance agent and broker. We provide options for coverage by sourcing it through one of our insurance partners. For more detailed information on either our licenses or any of our insurance partners, please see our Legal/ Regulatory Notice.'}
        </MainTextBlockStyled>

        <BottomLinksBlockStyled item lg={6.4}>
          <BottomLinksStyled>
            <div>© 2023 TheGuarantors {isPad ? '' : 'Inc.'}</div>
            <div>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/privacy?hsLang=en'}
              >
                Privacy Policy
              </Link>
            </div>
            <div>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/terms?hsLang=en'}
              >
                Terms of Service
              </Link>
            </div>
            <div>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/legal-regulatory?hsLang=en'}
              >
                {isPad ? 'Legal/Regulatory Notice' : 'Legal'}
              </Link>
            </div>
            <div>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/legal-regulatory?hsLang=en'}
              >
                {isPad ? 'Notice of Collection' : 'Regulatory Notice'}
              </Link>
            </div>
            <div>© 2023 TheGuarantors Inc.</div>
          </BottomLinksStyled>
        </BottomLinksBlockStyled>
      </FooterStyled>
    </>
  );
};

export default Footer;
